import { FC, createContext, useState, PropsWithChildren, SetStateAction, Dispatch } from 'react';

type CatalogEntryCarouselSeeMore = Record<string, string>;

export type CatalogEntryCarouselSeeMoreContextType = {
	entryCarouselSeeMore: CatalogEntryCarouselSeeMore;
	setEntryCarouselSeeMore: Dispatch<SetStateAction<CatalogEntryCarouselSeeMore>>;
};

export const CatalogEntryCarouselSeeMoreContext =
	createContext<CatalogEntryCarouselSeeMoreContextType>(
		{} as CatalogEntryCarouselSeeMoreContextType
	);

export const CatalogEntryCarouselSeeMoreProvider: FC<PropsWithChildren> = ({ children }) => {
	const [entryCarouselSeeMore, setEntryCarouselSeeMore] = useState<CatalogEntryCarouselSeeMore>({});

	return (
		<CatalogEntryCarouselSeeMoreContext.Provider
			value={{ entryCarouselSeeMore, setEntryCarouselSeeMore }}
		>
			{children}
		</CatalogEntryCarouselSeeMoreContext.Provider>
	);
};
